import { CalendlyService } from './../../services/calendly/calendly.service';
import { Institute } from './../../models/institute/randomInstituteResponse';
import { InstituteService } from './../../services/institute/institute.service';
import { Component, OnInit, ViewChild, AfterViewInit, effect, ChangeDetectorRef } from '@angular/core';
import { AskMeAnythingComponent } from './ask-me-anything/ask-me-anything.component';
import { CommonModule } from '@angular/common';
import { Store } from '@ngxs/store';
import { Router, RouterModule } from '@angular/router';
import { UserProfileStatus } from '../../models/account/userProfileStatus';
import { ButtonModule } from 'primeng/button';
import { MyInstitutesComponent } from '../my-institutes/my-institutes.component';
import { ScheduledCallsForStudentResponse } from '../../models/calendly/scheduledCallsForStudentResponse';
import { DialogModule } from 'primeng/dialog';
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';
import { forkJoin, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SchedulePeerCallService } from '../../services/schedule-peer-call/schedule-peer-call.service';
import { ScheduleCallResponse } from '../../models/schedule-peer-call/scheduleCallResponse';
import { TabViewModule } from 'primeng/tabview';
import { driver } from 'driver.js';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';

import { AdditionalInfo, GetAdditionalInformationResponse } from '../../models/account/additional-information/getAdditionalInformationResponse';
import { AdditionalInformationService } from '../../services/additional-information/additional-information.service';
import { AdditionalInformation } from '../../models/enums/additionalInformation';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FileSelectEvent, FileUpload, FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { TourService } from '../../services/utility/tour.service';
import { SkipTour, UpdateUser } from '../../states/user/user-action';
import { ActivatedRoute } from '@angular/router';
import { PersonalInfoState } from '../../models/enums/peronsalInfoState';
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { ParentsInformationComponent } from './parents-information/parents-information.component';

import { DashboardWelcomeBannerComponent } from './dashboard-welcome-banner/dashboard-welcome-banner.component';
import { DashboardProfileCompletionComponent } from './dashboard-profile-completion/dashboard-profile-completion.component';
import { DashboardTestimonialsComponent } from './dashboard-testimonials/dashboard-testimonials.component';
import { DashboardQuickActionsComponent } from './dashboard-quick-actions/dashboard-quick-actions.component';
import { DashboardMilestonesComponent } from './dashboard-milestones/dashboard-milestones.component';
import { DashboardApplicationsComponent } from './dashboard-applications/dashboard-applications.component';
import { DashboardPromoSectionsComponent } from './dashboard-promo-sections/dashboard-promo-sections.component';
import { DashboardSkeletonComponent } from './dashboard-skeleton/dashboard-skeleton.component';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { StudentProgressService } from '../../services/account/student-progress.service';
import { ProfileStatusResponse } from '../../models/account/profileStatusResponse';
import { StudentProgressStatsResponse } from '../../models/account/studentProgressStatsResponse';
import { StudentProgressInfoResponse } from '../../models/account/studentProgressInfoResponse';
import { LoginStreakResponse } from '../../models/account/loginStreakResponse';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [DashboardWelcomeBannerComponent, DashboardProfileCompletionComponent, DashboardTestimonialsComponent, DashboardQuickActionsComponent, DashboardMilestonesComponent, DashboardApplicationsComponent, DashboardPromoSectionsComponent, DashboardSkeletonComponent, AskMeAnythingComponent, CalendarModule, DropdownModule, FormsModule, ReactiveFormsModule, FileUploadModule, CommonModule, MyInstitutesComponent, RouterModule, ButtonModule, DialogModule, TabViewModule, PersonalInfoComponent, ParentsInformationComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})

export class DashboardComponent implements OnInit, AfterViewInit {
  public AdditionalInformation = AdditionalInformation;
  public PersonalInfoState = PersonalInfoState;

  visible: boolean = false;
  visibleTest: boolean = false;
  isLoading: boolean = false;
  personalInfoDialogVisible: boolean = false;

  //Flag to prevent loop when tour ends/skips
  tourJustFinished: boolean = false;

  date2: Date | undefined;

  showTestDialog() {
    this.visibleTest = true;
  }

  visibleInfo: boolean = false;
  showInfoDialog() {
    this.visibleInfo = true;
  }


  showDialog(itemid: number, currentAdditionalInfoSection: AdditionalInformation) {
    this.selectedItemSection = currentAdditionalInfoSection;
    this.selectedItemId = itemid;
    this.visible = true;
  }

  closeReply() {
    this.visible = false;
    this.attachment = undefined;
    this.fileUploader.clear();
    this.resetForm();
  }

  resetForm() {
    this.additionalInformationForm.reset();
    this.additionalInformationForm.clearValidators();
  }

  user: UserStateModel | undefined;
  isNewUser: boolean = false;
  peerMeetingList: ScheduleCallResponse[] = [];

  welcomeDialogVisible: boolean = false;
  applicationCount: number = 0;

  // Dashboard progress / view-state (driven by the three progress endpoints)
  isDashboardLoading: boolean = true;
  isReturningStudent: boolean = false;
  private progressRequested: boolean = false;
  profileStatusInfo: ProfileStatusResponse | undefined;
  progressStats: StudentProgressStatsResponse | undefined;
  progressInfo: StudentProgressInfoResponse | undefined;
  loginStreak: LoginStreakResponse | undefined;
  journeyEvents: any[] = [];

  loadingInstituteId: string | null = null; // or number if you use index
  myInstitutes: Institute[] = [];
  profileStatus: UserProfileStatus | undefined;
  meetings: ScheduledCallsForStudentResponse[] = [];

  pendingProfileTasks: GetAdditionalInformationResponse | undefined;
  pendingDocumentTasks: GetAdditionalInformationResponse | undefined;
  pendingCheckListTasks: GetAdditionalInformationResponse | undefined;
  pendingEssayPilotTasks: GetAdditionalInformationResponse | undefined;
  pendingGeneralTasks: GetAdditionalInformationResponse | undefined;
  selectedItemSection: AdditionalInformation | undefined;
  attachment: File | undefined;
  submitted: boolean = false;
  selectedItemId: number | null = null;
  additionalInformationForm!: FormGroup;

  initializeForm() {
    this.additionalInformationForm = this.formBuilder.group({
      additionalInfo: ['', Validators.required]
    });
  }

  @ViewChild('fileUploader') fileUploader!: FileUpload;
  private tourDriver: any;

  source: string | null = null;

  constructor(private store: Store, private instituteService: InstituteService,
    private router: Router, private calendlyService: CalendlyService,
    private schedulePeerCallService: SchedulePeerCallService,
    private formBuilder: FormBuilder,
    private additionalInformationService: AdditionalInformationService,
    private messageService: MessageService,
    private tourService: TourService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private studentProgressService: StudentProgressService
  ) {
    effect(() => {
      if (this.tourService.startTourSignal()) {
        this.startTour();
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.source = params.get('source');
      if (this.source) {
        // Use this.source for display, analytics, or tracking
        console.log('Dashboard lead source:', this.source);
      }
    });

    this.getStudentMeetings();
    this.observeMeetings();
    this.loadMeetingData();
    this.initializeForm();

    this.store.select(MyInstitutesSelectors.getMyInstitute).subscribe({
      next: (response: any) => {
        if (response && response.items) {
          this.myInstitutes = response.items;
        }
      }
    });
  }


  ngAfterViewInit(): void {
    this.initializeTour();
  }

  openAttachment(fileUrl: string | undefined) {
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }

  skipTour() {
    // Set flag to true so the data subscriber knows we just finished the tour
    this.tourJustFinished = true;

    const accountData = localStorage.getItem("account");
    if (accountData) {
      const account = JSON.parse(accountData);
      account.isNewUser = false;
      localStorage.setItem("account", JSON.stringify(account));
      this.store.dispatch(new SkipTour({ isNewUser: false }))
    }
    this.welcomeDialogVisible = false;
  }

  loadMeetingData() {
    this.isLoading = true;
    this.store.select(UserSelectors.getUser).pipe(
      switchMap(user => {
        if (!user || !user.id) {
          return of(null);
        }
        this.user = user;
        this.isNewUser = user.isNewUser

        // Load progress data up-front so the correct dashboard view is rendered
        // directly (no first-login -> returning flash); a skeleton shows meanwhile.
        this.loadDashboardProgress(user.id);

        // 1. Check for personal info FIRST
        // ONLY open the dialog if we didn't just finish/skip the tour
        // if (!this.tourJustFinished) {
        //   this.checkAndShowPersonalInfoDialog();
        // }

        // 2. Only show Tour immediately if User is New AND they have already completed Personal/Parent info previously
        if (this.isNewUser && user.personalInfoState === PersonalInfoState.Completed) {
          this.welcomeDialogVisible = true;
        }

        return this.schedulePeerCallService.getAllScheduledCallsForStudent(user.id);
      })
    ).subscribe({
      next: (response) => {
        if (response != null) {
          this.isLoading = false;
          this.peerMeetingList = response?.result ?? [];
          this.getPendingQuestionByType(AdditionalInformation.Profile);
          this.getPendingQuestionByType(AdditionalInformation.Document);
          this.getPendingQuestionByType(AdditionalInformation.CheckList);
          this.getPendingQuestionByType(AdditionalInformation.EssayPilot);
          this.getPendingQuestionByType(AdditionalInformation.General);
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.warn('Error fetching user and meeting list:', error);
      }
    });
  }

  loadDashboardProgress(studentId: string): void {
    // Guard: the user selector can emit multiple times; only fetch once.
    if (this.progressRequested || !studentId) {
      return;
    }
    this.progressRequested = true;
    this.isDashboardLoading = true;

    forkJoin({
      profileStatus: this.studentProgressService.getProfileStatus(studentId).pipe(catchError(() => of(undefined))),
      progressStats: this.studentProgressService.getStudentProgressStats(studentId).pipe(catchError(() => of(undefined))),
      progressInfo: this.studentProgressService.getStudentProgressInfo(studentId).pipe(catchError(() => of(undefined))),
      loginStreak: this.studentProgressService.getLoginStreak(studentId).pipe(catchError(() => of(undefined)))
    }).subscribe({
      next: ({ profileStatus, progressStats, progressInfo, loginStreak }) => {
        this.profileStatusInfo = profileStatus;
        this.progressStats = progressStats;
        this.progressInfo = progressInfo;
        this.loginStreak = loginStreak;
        this.isReturningStudent = this.computeIsReturningStudent(progressStats, progressInfo);
        this.journeyEvents = this.buildJourneyEvents(progressInfo);
        this.isDashboardLoading = false;
      },
      error: () => {
        // On failure, fall back to the first-login (new student) view.
        this.isReturningStudent = false;
        this.isDashboardLoading = false;
      }
    });
  }

  private computeIsReturningStudent(
    stats: StudentProgressStatsResponse | undefined,
    info: StudentProgressInfoResponse | undefined
  ): boolean {
    const hasStats = !!stats && (
      stats.profileCompletionPercentage > 0 ||
      stats.collegeSavedCount > 0 ||
      stats.uploadedDocumentsCount > 0 ||
      stats.savedScholarshipCount > 0 ||
      stats.hasMentor
    );
    const hasInfo = !!info && (
      info.hasProfileCompleted ||
      info.hasDocumentsUploaded ||
      info.hasMentorAssigned ||
      info.hasInstituteShortlisted ||
      info.hasApplicationSubmitted
    );
    return hasStats || hasInfo;
  }

  // Profile-completion checklist for the dashboard card — mirrors the
  // view-profile completion sections, each driven by the profile-status flags.
  // get profileCompletionItems(): { label: string; done: boolean }[] {
  //   const s = this.profileStatusInfo;
  //   return [
  //     { label: 'Personal Details', done: !!s?.hasPersonalDetails },
  //     { label: 'Education', done: !!s?.hasEducationDetails },
  //     { label: 'Recommendations', done: !!s?.hasRecommendationsDetails },
  //     { label: 'Awards & Accolades', done: !!s?.hasAwardsAndAccoladesDetails },
  //     { label: 'Test Scores', done: !!s?.hasTestScoresDetails },
  //     { label: 'Experience', done: !!s?.hasExperiencesDetails }
  //   ];
  // }
get profileCompletionItems(): { label: string; done: boolean }[] {
  const s = this.profileStatusInfo;
  return [
    { label: 'Personal Details',   done: !!s?.hasPersonalDetails },
    { label: 'Education',          done: !!s?.hasEducationDetails },
    { label: 'Test Scores',        done: !!s?.hasTestScoresDetails },
    { label: 'Experience',         done: !!s?.hasExperiencesDetails },
    { label: 'Recommendations',    done: !!s?.hasRecommendationsDetails },
    { label: 'Awards & Accolades', done: !!s?.hasAwardsAndAccoladesDetails }
  ];
}
  private buildJourneyEvents(info: StudentProgressInfoResponse | undefined): any[] {
    return [
      { title: 'Complete Profile', description: 'You took the first step towards your dream.', icon: 'pi-user', color: '#1E40AF', completed: !!info?.hasProfileCompleted, linkLabel: 'Complete Profile', route: '/portal/application-form' },
      { title: 'Documents Uploaded', description: 'Great start! You\'ve uploaded important documents.', icon: 'pi-file', color: '#6D28D9', completed: !!info?.hasDocumentsUploaded, linkLabel: 'Upload Documents', route: '/portal/student-document-vault' },
      { title: 'First Mentor Session Request', description: 'You connection request with a mentor and got expert guidance.', icon: 'pi-calendar', color: '#F59E0B', completed: !!info?.hasMentorAssigned, linkLabel: 'View Mentors', route: '/portal/mentor-me' },
      { title: 'University Shortlists', description: 'You shortlisted universities that match your goals.', icon: 'pi-home', color: '#3B82F6', completed: !!info?.hasInstituteShortlisted, linkLabel: 'Discover University', route: '/portal/institute-search' },
      // 'Applications Started' is intentionally always shown as incomplete and pinned to the end.
      { title: 'Applications Started', description: 'You\'ve started your applications. Keep the momentum!', icon: 'pi-send', color: '#10B981', completed: false, alwaysLast: true, linkLabel: 'Track Application', route: '/portal/my-institutes' }
    ];
  }

  onReplySubmit() {
    this.isLoading = true;
    this.submitted = false;
    if (this.additionalInformationForm.invalid) {
      this.isLoading = false;
      return;
    }
    this.additionalInformationService.updateAdditionalInformation({
      id: this.selectedItemId!,
      reply: this.additionalInformationForm.value.additionalInfo,
      attachment: this.attachment
    }).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.submitted = false;
        this.additionalInformationForm.reset();
        this.attachment = undefined;
        this.fileUploader.clear();
        this.closeReply();
        this.removeItemFromPending();
        this.messageService.add({ severity: "success", summary: "Success", detail: "Information updated successfully!" });
      },
      error: (err) => {
        this.isLoading = false;
        console.warn(`Error While Retriving Task Information:${err}`);
      }
    })
  }

  removeItemFromPending() {
    switch (this.selectedItemSection) {
      case AdditionalInformation.Profile:
        if (!this.pendingProfileTasks?.additionalInfo || !this.selectedItemId) return;
        {
          const itemIndex = this.pendingProfileTasks.additionalInfo.findIndex(item => item.id === this.selectedItemId);
          if (itemIndex !== -1) {
            this.pendingProfileTasks.additionalInfo.splice(itemIndex, 1)[0];
          }
        }
        break;
      case AdditionalInformation.CheckList:
        if (!this.pendingCheckListTasks?.additionalInfo || !this.selectedItemId) return;
        {
          const itemIndex = this.pendingCheckListTasks.additionalInfo.findIndex(item => item.id === this.selectedItemId);
          if (itemIndex !== -1) {
            this.pendingCheckListTasks.additionalInfo.splice(itemIndex, 1)[0];
          }
        }
        break;
      case AdditionalInformation.Document:
        if (!this.pendingDocumentTasks?.additionalInfo || !this.selectedItemId) return;
        {
          const itemIndex = this.pendingDocumentTasks.additionalInfo.findIndex(item => item.id === this.selectedItemId);
          if (itemIndex !== -1) {
            this.pendingDocumentTasks.additionalInfo.splice(itemIndex, 1)[0];
          }
        }
        break;
      case AdditionalInformation.EssayPilot:
        if (!this.pendingEssayPilotTasks?.additionalInfo || !this.selectedItemId) return;
        {
          const itemIndex = this.pendingEssayPilotTasks.additionalInfo.findIndex(item => item.id === this.selectedItemId);
          if (itemIndex !== -1) {
            this.pendingEssayPilotTasks.additionalInfo.splice(itemIndex, 1)[0];
          }
        }
        break;
      case AdditionalInformation.General:
        if (!this.pendingGeneralTasks?.additionalInfo || !this.selectedItemId) return;
        {
          const itemIndex = this.pendingGeneralTasks.additionalInfo.findIndex(item => item.id === this.selectedItemId);
          if (itemIndex !== -1) {
            this.pendingGeneralTasks.additionalInfo.splice(itemIndex, 1)[0];
          }
        }
        break;
    }
  }

  getPendingQuestionByType(type: AdditionalInformation) {
    if (!this.user) return;

    this.additionalInformationService.getAdditionalInformation({
      studentId: this.user.id,
      type: type,
      status: 'Pending'
    }).subscribe({
      next: (response) => {
        switch (type) {
          case AdditionalInformation.Profile:
            this.pendingProfileTasks = response;
            break;
          case AdditionalInformation.Document:
            this.pendingDocumentTasks = response;
            break;
          case AdditionalInformation.CheckList:
            this.pendingCheckListTasks = response;
            break;
          case AdditionalInformation.EssayPilot:
            this.pendingEssayPilotTasks = response;
            break;
          case AdditionalInformation.General:
            this.pendingGeneralTasks = response;
            break;
        }
      },
      error: (err) => {
        console.warn('Error in getAdditionalInformation', err);
      }
    })
  }


  observeMeetings() {
    this.calendlyService.schduledMeetingForStudent$.subscribe({
      next: (meeting: ScheduledCallsForStudentResponse) => {
        this.meetings.unshift(meeting);
      },
      error: (err) => {
        console.warn('Error in scheduledMeetingForStudent$', err);
      },
      complete: () => {
      }
    });

    this.calendlyService.canceledMeetingForStudent$.subscribe({
      next: (meeting: ScheduledCallsForStudentResponse) => {
        const index = this.meetings.findIndex((m) => m.id === meeting.id);
        if (index !== -1) {
          this.meetings.splice(index, 1);
        }
      },
      error: (err) => {
        console.warn('Error in canceledMeetingForStudent$', err);
      },
      complete: () => { }
    });

    this.calendlyService.reSchduledMeetingForStudent$.subscribe({
      next: (meeting: ScheduledCallsForStudentResponse) => {
        this.meetings.unshift(meeting);
      },
      error: (err) => {
        console.warn('Error in scheduledMeetingForStudent$', err);
      },
      complete: () => {
      }
    });
  }

  showWelcomeDialog(): void {
    this.welcomeDialogVisible = true;
  }

  private initializeTour(): void {
    this.tourDriver = driver({
      showProgress: true,
      stagePadding: 3,
      allowClose: true,
      disableActiveInteraction: false,
      onHighlightStarted: () => {
        // Add CSS class to body when tour starts
        document.body.classList.add('driver-active');
      },
      onDestroyed: () => {
        // Remove CSS class from body when tour ends
        document.body.classList.remove('driver-active');
        // Called when tour ends (either completed or skipped)
        this.onTourEnd();
      },
      steps: [
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(1)',
          popover: {
            title: 'Dashboard',
            description: 'Your main hub for all activities. View your progress, tasks, and upcoming events.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(2)',
          popover: {
            title: 'My Colleges',
            description: 'Manage your list of target universities and track your application status.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(3)',
          popover: {
            title: 'College Search',
            description: 'Search and explore universities to find the perfect match for your academic goals.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(4)',
          popover: {
            title: 'Essay Pilot',
            description: 'Access our essay writing platform to craft and store your application essays.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(5)',
          popover: {
            title: 'Mentor Me',
            description: 'Connect with experienced mentors who can guide you through your High-Ed  journey.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.p-menubar-root-list > .p-menuitem:nth-child(6)',
          popover: {
            title: 'Resources',
            description: 'Access profile-building opportunities and resources to enhance your application.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.notifications.p-button',
          popover: {
            title: 'Notifications',
            description: 'Stay updated with important alerts and messages about your application process.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.user_drop.p-button',
          popover: {
            title: 'Account Menu',
            description: 'Access your account center, complete your profile, manage documents, and more.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '#mentor',
          popover: {
            title: 'Mentor Me',
            description: 'Connect with experienced mentors to guide you through your Higher-Education journey.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.flipCon:nth-child(2)',
          popover: {
            title: 'Psychometric Test',
            description: 'Take our psychometric test to better understand your strengths and preferences.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.flipCon:nth-child(3)',
          popover: {
            title: 'Explore Colleges',
            description: 'Browse through universities to find the perfect match for your academic goals.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.flipCon:nth-child(4)',
          popover: {
            title: 'Essay Pilot',
            description: 'Use our essay writing platform to craft and store your application essays.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.flipCon:nth-child(5)',
          popover: {
            title: 'Check List',
            description: 'Track your application progress and ensure you meet all requirements.',
            side: 'bottom',
            align: 'center'
          }
        },
        {
          element: '.flipCon:nth-child(6)',
          popover: {
            title: 'General Tasks',
            description: 'Access all your tasks and activities in one place.',
            side: 'bottom',
            align: 'center'
          }
        }
      ]
    });
  }

  startTour(): void {
    this.welcomeDialogVisible = false;
    if (this.tourDriver) {
      this.tourDriver.drive();
    }
  }

  OpenCheckList(): void {
    this.router.navigate(['portal', 'checklist']);
  }

  OpenEssayPilot(): void {
    this.router.navigate(['portal', 'essay-pilot']);
  }

  OpenMentorConnect(): void {
    this.router.navigate(['portal', 'mentor-me']);
  }

  OpenPeerConnect(): void {
    this.router.navigate(['portal', 'peer']);
  }

  OpenExploreColleges(): void {
    this.router.navigate(['portal', 'institute-search']);
  }

  OpenCompeleteProfile(): void {
    this.router.navigate(['portal', 'application-form']);
  }

  OpenPsychometricTest() {
    this.router.navigate(['portal', 'psychometric-test']);
  }

  OpenDirectApply() {
    this.router.navigate(['portal', 'da-forms']);
  }


  getStudentMeetings(): void {
    this.calendlyService.getStudentMeetings().subscribe({
      next: (response: { result: ScheduledCallsForStudentResponse[] }) => {
        this.meetings = response.result;
      },
      error: (error: unknown) => {
        console.warn('error while retriving meetings', error);
      }
    });
  }

  onFileSelect(event: FileSelectEvent): void {
    if (event.files && event.files.length > 0) {
      const filesArray = Array.from(event.files);
      let index = 0;
      filesArray.forEach((item, idx) => {
        if (item.size > 1048576) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${item.name} file size can't exceed 1 MB`
          });
          filesArray.splice(idx, 1);
          this.fileUploader.clear();
        }
        index++;
      });
      if (filesArray.length > 0) {
        this.attachment = filesArray[0];
      }
    }
  }

  getLocalDate(dateArg: string): string {
    const date = new Date(dateArg);
    const localDate = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    }).replace(/(\d{2}) (\w+) (\d{4})/, '$2 $1, $3');
    return localDate;
  }

  getLocalTime(dateArg: string): string {
    const date = new Date(dateArg);
    const localTime = date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).toUpperCase();
    return localTime;
  }

  openCalendlyURI(uri: string): void {
    window.open(uri, '_blank');
  }

  onFileRemoved() {
    this.attachment = undefined;
    if (this.fileUploader) {
      this.fileUploader.clear();   // ✅ This clears the UI preview 
    }
    this.cdr.detectChanges();      // Force UI refresh
  }

  // openPeerMeetingURL(arg0: any) {
  //   window.open(arg0, '_blank');
  // }

  private checkAndShowPersonalInfoDialog(): void {
    // Only show dialog if user has pending personal info
    if (this.user?.personalInfoState === PersonalInfoState.StudentInfoPending ||
      this.user?.personalInfoState === PersonalInfoState.ParentsInfoPending) {
      this.personalInfoDialogVisible = true;
    }
  }

  public onTourEnd(): void {
    // This will be called when the tour finishes
    // if (this.isNewUser) {
    // For new users, show personal info dialog after tour ends
    //   this.checkAndShowPersonalInfoDialog();
    // }

    // Set flag to prevent dialog from popping up again immediately
    this.tourJustFinished = true;
  }

  public closePersonalInfoDialog(): void {
    this.personalInfoDialogVisible = false;
  }


  public onPersonalInfoUpdateSuccess(): void {
    this.closePersonalInfoDialog();
    // Update user state to prevent dialog from showing again
    if (this.user) {
      this.user.personalInfoState = PersonalInfoState.Completed;
      // Update the store with the new state
      this.store.dispatch(new UpdateUser({
        id: this.user.id,
        email: this.user.email,
        phoneNumber: this.user.phoneNumber,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        role: this.user.role,
        isNewUser: this.user.isNewUser,
        profileImageUrl: this.user.profileImageUrl,
        personalInfoState: PersonalInfoState.Completed,
        profileImageFormat: this.user.profileImageFormat
      }));
    }
  }

  public onShowParentsInfo(): void {
    if (!this.user) return;
    this.personalInfoDialogVisible = true;
    this.user.personalInfoState = PersonalInfoState.ParentsInfoPending;
    // Update the store with the new state
    this.store.dispatch(new UpdateUser({
      id: this.user.id,
      email: this.user.email,
      phoneNumber: this.user.phoneNumber,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      role: this.user.role,
      isNewUser: this.user.isNewUser,
      profileImageUrl: this.user.profileImageUrl,
      personalInfoState: PersonalInfoState.ParentsInfoPending,
      profileImageFormat: this.user.profileImageFormat
    }));
  }
  // Close personal info dialog and keep the main dialog open for parents info
  // The dialog will automatically show parents info component due to the state change
  // No need to close the dialog as the template will switch components based on user state

  // ADDED: This function triggers the tour when the info dialog closes
  public onPersonalInfoDialogHide(): void {
    // If the user manually closes the dialog (Skipping Parent info) OR finishes submitting
    // and they are a new user, trigger the tour.
    if (this.isNewUser) {
      this.welcomeDialogVisible = true;
    }
  }
}